import React, {Component} from 'react';

export default class Loading extends Component {
    shouldComponentUpdate() {
        return false;
    }

    render() {
        return (
            <div className='cielo24-vwrap-loading'>
                <div className='cielo24-vwrap-spinner' />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./scripts/components/layout/loading.js